import React from "react";
import { Edit, SimpleForm, TextInput, SelectInput, required, TopToolbar, Button, useRedirect, useNotify, usePermissions } from "react-admin";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";

const UserEdit = () => {

  const redirect = useRedirect();
  const notify = useNotify();
  const { id } = useParams(); 
  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, marginBottom:-2 }}>
        <TopToolbar>
            <Button
                label="ユーザー表示"
                onClick={() => redirect(`/users/show/${id}`)}
                startIcon={<VisibilityIcon />}
            />
        </TopToolbar>
    </Box>
  );

  const {permissions} = usePermissions();
  if(permissions < 1){
    return;
  }

  return (
    <>
      <CustomTopToolbar/>
      <Edit mutationMode="pessimistic" 
        mutationOptions={{ 
          onSuccess: (data) => {
            notify('更新が完了しました', { type: 'success' }); 
            redirect('list', 'users');
          }
        }}
      >
      <SimpleForm
        onKeyDown={e => {
          if (e.key === 'Enter') {
              e.preventDefault();
          }
        }}
      >
        <TextInput source="userName" label="ユーザー名" validate={required()} />
          <TextInput source="name" label="名前" validate={required()}/>
          <TextInput source="mail" label="メール" type="email" />
          <SelectInput
            source="userType"
            label="ユーザー種別"
            choices={[
              { id: 0, name: "一般スタッフ" },
              { id: 1, name: "管理スタッフ" },
              // { id: 2, name: "マスター" },
            ]}
            validate={required()}
          />
        </SimpleForm>
      </Edit>
    </>
  )

};

export default UserEdit;
